export default [
  {
    path: "/menu",
    component: resolve => require(["@/views/menu.vue"], resolve),
    redirect: "/menu/home",
    children: [
      {
        path: "content",
        component: resolve => require(["@/views/content/index.vue"], resolve),
        children: [
          {
            path: "form/list",
            meta: {
              nameText: "表单列表",
            },
            component: resolve => require(["@/modules/form/pages/formList/list.vue"], resolve),
          },
          {
            path: "form/type",
            name: "home",
            meta: {
              nameText: "数据分析",
            },
            component: resolve => require(["@/modules/form/pages/formList/type.vue"], resolve),
          },

          {
            path: "form/edit/:id",
            name: "editFrom",
            component: resolve => require(["@/modules/form/pages/formList/editFrom.vue"], resolve),
            meta: {
              nameText: "编辑表单",
            },
          },
          {
            path: "form/extensionForm/:id",
            name: "extensionForm",
            component: resolve => require(["@/modules/form/pages/formList/extensionForm.vue"], resolve),
            meta: {
              nameText: "表单推广渠道",
            },
          },
          {
            path: "form/report/:id",
            name: "report",
            component: resolve => require(["@/modules/form/pages/formList/report.vue"], resolve),
            meta: {
              nameText: "表单统计",
            },
          },
        ],
      },
    ],
  }
];
